import { useCallback, useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';

export function useShareInvite(inviteToken?: string) {
  const [copied, setCopied] = useState(false);
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null);

  const inviteUrl = inviteToken
    ? `${window.location.origin}/invite/${inviteToken}`
    : '';

  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  const handleCopy = useCallback(async () => {
    if (!inviteUrl) return;
    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopied(true);
      toast.success('Link copiado!');
      timeoutRef.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      toast.error('Erro ao copiar link');
    }
  }, [inviteUrl]);

  const handleShare = useCallback(async () => {
    if (!inviteUrl) return;
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Convite eumimo',
          text: 'Vem compartilhar desejos e momentos especiais comigo no eumimo!',
          url: inviteUrl,
        });
      } catch (error) {
        if ((error as Error).name !== 'AbortError') {
          toast.error('Erro ao compartilhar');
        }
      }
    } else {
      handleCopy();
    }
  }, [inviteUrl, handleCopy]);

  return { inviteUrl, copied, handleCopy, handleShare };
}
